import React from "react";

import moment from "moment";
import Fire from "../../config/Fire";
import Colors from "../Colors";
import Aux from "../AuxFunctions";
//import moment from "moment";

class ChatMessage extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showTime: false,
        }
    }

    getTime = (timestamp) => {
        try {
            if (!timestamp)
                return null
            return moment(timestamp.toDate()).fromNow();
            //return moment(timestamp.toDate()).format("h:mm A")
        } catch (error) {
            Aux.handleError(error)
            return null
        }
    }
    render() {
        try {
            const { text, from } = this.props.message;
            const imSender = from === Fire.shared.uid ? true : false;
            if(this.props.message.system){
                return (
                    <div style={{display:"flex", margin:"5px 0", width:"auto", alignSelf:"center"}}>
                            <span style={{color: Colors.softText}}>{text}</span>
                    </div>
                )
            }else if(imSender){
                return (
                    <div style={{display:"flex", justifyContent:"flex-end"}} onClick={() => this.setState({showTime: !this.state.showTime})}>
                        {this.state.showTime ? 
                        <span style={{color:Colors.softText, fontSize:10, margin:5}}>
                            {this.getTime(this.props.message.timestamp)}
                        </span> : null }
                        <div style={{display:"flex", maxWidth:"70%", marginRight:15}}>
                            <div style={{display:"flex",  backgroundColor: Colors.mainColor, margin:"5px 0", padding:"5px 10px", borderRadius:5, }}>
                                <span style={{color:"white"}}>{text}</span>
                            </div>
                        </div>
                    </div>
                )
            }else {
                return (
                    <div style={{display:"flex",}} onClick={() => this.setState({showTime: !this.state.showTime})}>
                        {/* {this.state.user ? 
                            <div style={{marginRight:5, marginTop:10}}>
                            {Aux.showAvatar(20, this.state.user.avatar, this.state.user.username || "Unknown")  }
                            </div>: null} */}
                        <div style={{display:"flex", backgroundColor: "#efefef", margin:"5px 0", marginLeft:15, padding:"5px 10px", borderRadius:5, maxWidth:"70%", alignSelf: "start"}}>
                            <span style={{ color: Colors.darkText }}>{text}</span>
                        </div>
                        {this.state.showTime ? 
                        <span style={{color:Colors.softText, fontSize:10, margin:5}}>
                            {this.getTime(this.props.message.timestamp)}
                        </span> : null }
                        {/* <span style={{color:Colors.softText, fontSize:10, margin:5}}>{this.getTime(this.props.message.timestamp)}</span> */}
                    </div>
                )
            }
        } catch (error) {
            Aux.handleError(error)
            return null
        }
    }
}

export default ChatMessage;